import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { editReqFields } from "../../../constants/aseInternalTicketRequiredFields";
import { editRights } from "../../../constants/aseInternalTicketRights";
import formMessages from "../../../intl/afterSales/formMessages";
import formTypeMessages from "../../../intl/common/formTypeMessages";
import { formatInternalTicketNumber } from "../../../utils/utils";
import Loader from "../../Loader";
import PageHeader from "../../common/PageHeader";
import ValidFormattedMessage from "../../common/ValidFormattedMessage";
import checkRoles from "../../common/roleChecker/RoleChecker";
import { initLoadedAseInternalTicket } from "../Utils";
import InternalTechnicalBulletinTicketMasterForm from "./forms/InternalTechnicalBulletinTicketMasterForm";

class EditLoadInternalTechnicalBulletinTicketDataPage extends React.Component {
    render() {
        const { ticketData, clientIds, handleSubmit, formType } = this.props;
        if (clientIds.isLoading) {
            return <Loader />;
        }
        const requiredFields =
            editReqFields[
                editReqFields[ticketData.ticket.group]
                    ? ticketData.ticket.group
                    : "DEFAULT"
            ]["SG_EDITOR"][formType];
        const initializationValue = initLoadedAseInternalTicket(ticketData);

        return (
            <div id="ticketPrint" className="container-fluid">
                <PageHeader
                    title={
                        <>
                            <FormattedMessage {...formMessages.TICKET} />{" "}
                            {formatInternalTicketNumber(
                                ticketData.ticket.pfxNumber,
                                ticketData.ticket.sfxNumber,
                            )}
                            {"-"}
                            <ValidFormattedMessage
                                message={formType}
                                intlMessages={formTypeMessages}
                            />
                        </>
                    }
                />
                <div>
                    <InternalTechnicalBulletinTicketMasterForm
                        form={formType}
                        initialValues={initializationValue}
                        userRights={
                            editRights["AS_SG_EDITOR"][ticketData.ticket.status]
                        }
                        enableReinitialize={true}
                        handleSubmit={handleSubmit}
                        reqFields={requiredFields}
                        readOnly={false}
                        showDocumentationUpdate
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    ticketData: state.aseInternalTicket,
    clientIds: state.adminClientIds,
});

EditLoadInternalTechnicalBulletinTicketDataPage.propTypes = {
    location: PropTypes.object,
    ticketData: PropTypes.object.isRequired,
};

export default checkRoles(
    connect(
        mapStateToProps,
        {},
    )(EditLoadInternalTechnicalBulletinTicketDataPage),
    ["AS_SG_EDITOR"],
);

